import get from 'lodash/get';
import locales from './locales.json';

export default function t(key, defaultValue = '') {
  return get(locales, key, defaultValue);
}
